import { createContext, useContext, useState } from "react";

const GeoPiCtx = createContext(null);

export const GeoPiProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [project, setProject] = useState(null);
  return <GeoPiCtx.Provider value={{ open, setOpen, project, setProject }}>{children}</GeoPiCtx.Provider>;
};

export const useGeoPi = () => useContext(GeoPiCtx) || { open: false, setOpen: () => {}, project: null, setProject: () => {} };
